/**
 * @param startRange
 * @returns {{init(): void, range: number}}
 */
export function beforeAfter(startRange = 50) {

  let draggerEl = null;
  let clippedEl = null;

  return {
    range: 0,
    init() {
      clippedEl = this.$refs.before;
      draggerEl =  this.$refs.dragger;

      if(!clippedEl || !draggerEl) {
        console.log('`before` and/or `dragger` elements not found.');
        return;
      }

      this.$watch('range', value => {
        let style = `polygon(0% 0%, ${value}% 0%, ${value}% 100%, 0% 100%)`;
        clippedEl.style.clipPath = style;
        draggerEl.style.left = `${value}%`;
      });

      this.$nextTick(() => {
        this.range = startRange;
      });
    }
  };
}
